// import axios from "axios";
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import {
//   IoAdd,
//   IoClose,
//   IoCreateOutline,
//   IoTrashOutline,
//   IoImageOutline,
//   IoEyeOutline,
// } from "react-icons/io5";
// // import "./EnglishCours.css"; // shared admin styles (ec-*). Adjust the path if needed.
// import "./HomeUpdate.css"; // small extras for this page (hu-*)

// // REACT_APP_API_BASEURL is expected to look like  http://localhost:5001/api
// const API_BASE_URL = (process.env.REACT_APP_API_BASEURL || "").replace(/\/$/, "");
// const BASE = `${API_BASE_URL}/admin/home-updates`;
// // Images are saved in Uploads/ and served the same way as slides: <api>/uploads/<filename>
// const UPLOADS_URL = `${API_BASE_URL}/uploads/`;

// const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMAGE = 5 * 1024 * 1024; // 5 MB (same limit the server enforces)
// const PAGE_SIZE = 12;
// const IDEAL_RATIO = 4 / 5; // recommended popup shape (e.g. 1080 x 1350)

// const TABS = [
//   { key: "", label: "All" },
//   { key: "live", label: "Live" },
//   { key: "scheduled", label: "Scheduled" },
//   { key: "inactive", label: "Turned off" },
//   { key: "expired", label: "Expired" },
// ];

// const STATUS_LABEL = {
//   live: "Live",
//   scheduled: "Scheduled",
//   inactive: "Turned off",
//   expired: "Expired",
// };

// const FREQUENCY_LABEL = {
//   once: "Once per device",
//   daily: "Once a day",
// };

// const EMPTY_FORM = {
//   title: "",
//   startAt: "",
//   endAt: "",
//   priority: 0,
//   frequency: "once",
//   isActive: false,
// };

// // ---------- helpers ----------
// const authHeaders = () => ({
//   headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
// });

// const errMsg = (error, fallback = "Something went wrong. Please try again.") =>
//   error?.response?.data?.message || fallback;

// const imageUrl = (name) => (name ? `${UPLOADS_URL}${name}` : "");

// const pad = (n) => String(n).padStart(2, "0");

// // ISO / Date -> value for <input type="datetime-local"> in the admin's local time
// const toLocalInput = (value) => {
//   const d = new Date(value);
//   if (Number.isNaN(d.getTime())) return "";
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };

// const formatDateTime = (value) => {
//   const d = new Date(value);
//   if (Number.isNaN(d.getTime())) return "—";
//   return new Intl.DateTimeFormat("en-IN", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//   }).format(d);
// };

// const formatSize = (bytes) => {
//   const b = Number(bytes) || 0;
//   if (!b) return "—";
//   if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
//   return `${(b / (1024 * 1024)).toFixed(1)} MB`;
// };

// // Read the picked image's pixel size in the browser (nothing is uploaded here).
// const readImageSize = (file) =>
//   new Promise((resolve) => {
//     const url = URL.createObjectURL(file);
//     const img = new Image();
//     img.onload = () => {
//       URL.revokeObjectURL(url);
//       resolve({ width: img.naturalWidth, height: img.naturalHeight });
//     };
//     img.onerror = () => {
//       URL.revokeObjectURL(url);
//       resolve(null);
//     };
//     img.src = url;
//   });

// const ratioHint = (size) => {
//   if (!size?.width || !size?.height) return null;
//   const ok = Math.abs(size.width / size.height - IDEAL_RATIO) <= 0.06;
//   return {
//     ok,
//     text: ok
//       ? `${size.width} × ${size.height}: good shape for phone screens.`
//       : `${size.width} × ${size.height}: 4:5 (for example 1080 × 1350) fits phone screens best. Other shapes may look small or cropped.`,
//   };
// };

// const HomeUpdate = () => {
//   // ---------- shared ----------
//   const [toast, setToast] = useState(null);
//   const toastTimer = useRef(null);

//   const showToast = (type, text) => {
//     setToast({ type, text });
//     clearTimeout(toastTimer.current);
//     toastTimer.current = setTimeout(() => setToast(null), 3500);
//   };

//   useEffect(() => () => clearTimeout(toastTimer.current), []);

//   // ---------- list ----------
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [listError, setListError] = useState("");
//   const [status, setStatus] = useState("");
//   const [page, setPage] = useState(1);
//   const [pages, setPages] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [busyId, setBusyId] = useState(null);

//   // ---------- form modal ----------
//   const [modal, setModal] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [form, setForm] = useState(EMPTY_FORM);
//   const [errors, setErrors] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [progress, setProgress] = useState(0);

//   const [imageFile, setImageFile] = useState(null);
//   const [imagePreview, setImagePreview] = useState("");
//   const [existingImage, setExistingImage] = useState("");
//   const [imageSize, setImageSize] = useState(null);

//   // ---------- full-size preview ----------
//   const [lightbox, setLightbox] = useState(null); // { src, title }

//   // ============================================================
//   // object-URL housekeeping (avoid memory leaks)
//   // ============================================================
//   const previewRef = useRef("");
//   useEffect(() => {
//     previewRef.current = imagePreview;
//   }, [imagePreview]);
//   useEffect(
//     () => () => {
//       if (previewRef.current) URL.revokeObjectURL(previewRef.current);
//     },
//     []
//   );

//   const resetImage = () => {
//     if (imagePreview) URL.revokeObjectURL(imagePreview);
//     setImageFile(null);
//     setImagePreview("");
//     setExistingImage("");
//     setImageSize(null);
//   };

//   // ============================================================
//   // FETCH
//   // ============================================================
//   const fetchUpdates = useCallback(async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(BASE, {
//         ...authHeaders(),
//         params: { status: status || undefined, page, limit: PAGE_SIZE },
//       });
//       setItems(res.data?.data || []);
//       setPages(res.data?.pages || 1);
//       setTotal(res.data?.total || 0);
//       setListError("");
//     } catch (error) {
//       console.log(error);
//       setListError(errMsg(error, "Couldn't load updates. Please refresh."));
//     } finally {
//       setLoading(false);
//     }
//   }, [status, page]);

//   useEffect(() => {
//     fetchUpdates();
//   }, [fetchUpdates]);

//   const changeTab = (key) => {
//     setStatus(key);
//     setPage(1);
//   };

//   // ============================================================
//   // FORM ACTIONS
//   // ============================================================
//   const openCreate = () => {
//     resetImage();
//     const now = new Date();
//     const inAWeek = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
//     setEditingId(null);
//     setForm({
//       ...EMPTY_FORM,
//       startAt: toLocalInput(now),
//       endAt: toLocalInput(inAWeek),
//     });
//     setErrors({});
//     setProgress(0);
//     setModal(true);
//   };

//   const openEdit = (u) => {
//     resetImage();
//     setEditingId(u._id);
//     setForm({
//       title: u.title || "",
//       startAt: toLocalInput(u.startAt),
//       endAt: toLocalInput(u.endAt),
//       priority: u.priority ?? 0,
//       frequency: u.frequency || "once",
//       isActive: !!u.isActive,
//     });
//     setExistingImage(imageUrl(u.image));
//     setImageSize(
//       u.imageWidth && u.imageHeight ? { width: u.imageWidth, height: u.imageHeight } : null
//     );
//     setErrors({});
//     setProgress(0);
//     setModal(true);
//   };

//   const closeModal = () => {
//     if (saving) return;
//     resetImage();
//     setModal(false);
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
//   };

//   const pickImage = async (e) => {
//     const file = e.target.files?.[0];
//     e.target.value = "";
//     if (!file) return;
//     if (!IMAGE_TYPES.includes(file.type))
//       return setErrors((p) => ({ ...p, image: "Use a JPG, PNG or WebP image." }));
//     if (file.size > MAX_IMAGE)
//       return setErrors((p) => ({ ...p, image: "Image must be 5 MB or smaller." }));

//     setErrors((p) => ({ ...p, image: undefined }));
//     if (imagePreview) URL.revokeObjectURL(imagePreview);
//     setImageFile(file);
//     setImagePreview(URL.createObjectURL(file));
//     setImageSize(await readImageSize(file));
//   };

//   const validate = () => {
//     const e = {};
//     if (!form.title.trim()) e.title = "Give this update a name.";
//     else if (form.title.trim().length > 200) e.title = "Max 200 characters.";

//     if (!editingId && !imageFile) e.image = "Choose the image to show.";

//     const start = new Date(form.startAt);
//     const end = new Date(form.endAt);
//     if (!form.startAt || Number.isNaN(start.getTime())) e.startAt = "Pick a start date and time.";
//     if (!form.endAt || Number.isNaN(end.getTime())) e.endAt = "Pick an end date and time.";
//     if (!e.startAt && !e.endAt && end <= start) e.endAt = "End must be after the start.";

//     if (form.priority === "" || !Number.isInteger(Number(form.priority)))
//       e.priority = "Use a whole number.";

//     setErrors((p) => ({ ...e, image: e.image || p.image }));
//     return Object.keys(e).length === 0;
//   };

//   const submit = async (ev) => {
//     ev.preventDefault();
//     if (!validate()) return;

//     const fd = new FormData();
//     fd.append("title", form.title.trim());
//     fd.append("startAt", new Date(form.startAt).toISOString());
//     fd.append("endAt", new Date(form.endAt).toISOString());
//     fd.append("priority", Number(form.priority));
//     fd.append("frequency", form.frequency);
//     fd.append("isActive", form.isActive);
//     if (imageFile) fd.append("image", imageFile);

//     try {
//       setSaving(true);
//       setProgress(0);
//       const config = {
//         ...authHeaders(),
//         onUploadProgress: (p) => {
//           if (p.total) setProgress(Math.round((p.loaded * 100) / p.total));
//         },
//       };
//       if (editingId) {
//         await axios.patch(`${BASE}/${editingId}`, fd, config);
//         showToast("success", "Update saved.");
//       } else {
//         await axios.post(BASE, fd, config);
//         showToast("success", "Update created.");
//       }
//       resetImage();
//       setModal(false);
//       fetchUpdates();
//     } catch (error) {
//       console.log(error);
//       setErrors((p) => ({ ...p, submit: errMsg(error) }));
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ============================================================
//   // LIST ACTIONS
//   // ============================================================
//   const toggleActive = async (u) => {
//     try {
//       setBusyId(u._id);
//       await axios.patch(`${BASE}/${u._id}/toggle`, {}, authHeaders());
//       showToast("success", u.isActive ? "Update turned off." : "Update turned on.");
//       fetchUpdates();
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Couldn't change the update."));
//     } finally {
//       setBusyId(null);
//     }
//   };

//   const deleteUpdate = async (u) => {
//     if (!window.confirm(`Delete "${u.title}"? Its image will be removed from the server.`))
//       return;
//     try {
//       setBusyId(u._id);
//       await axios.delete(`${BASE}/${u._id}`, authHeaders());
//       showToast("success", "Update deleted.");
//       if (items.length === 1 && page > 1) setPage((p) => p - 1);
//       else fetchUpdates();
//     } catch (error) {
//       console.log(error);
//       showToast("error", errMsg(error, "Couldn't delete the update."));
//     } finally {
//       setBusyId(null);
//     }
//   };

//   // ============================================================
//   // RENDER
//   // ============================================================
//   const shownImage = imagePreview || existingImage;
//   const hint = ratioHint(imageSize);

//   return (
//     <div id="add-subject-inner-wrapper">
//       <div className="ec-page">
//         {/* ---------- header ---------- */}
//         <header className="ec-header">
//           <div>
//             <h1 className="ec-title">Home updates</h1>
//             <p className="ec-subtitle">
//               One image popup on the app’s home screen. Put any text, like “Diwali sale, 40% off”,
//               inside the image itself.
//             </p>
//           </div>
//           <button className="ec-btn ec-btn-primary" onClick={openCreate}>
//             <IoAdd size={18} /> New update
//           </button>
//         </header>

//         {toast && <div className={`ec-toast ec-toast-${toast.type}`}>{toast.text}</div>}

//         {/* ---------- list ---------- */}
//         <section>
//           <div className="ec-section-head">
//             <h2>Updates</h2>
//             <span className="ec-count">{total}</span>
//           </div>

//           <div className="hu-tabs" role="tablist" aria-label="Filter updates">
//             {TABS.map((t) => (
//               <button
//                 key={t.key || "all"}
//                 type="button"
//                 role="tab"
//                 aria-selected={status === t.key}
//                 className={`hu-tab ${status === t.key ? "hu-tab-active" : ""}`}
//                 onClick={() => changeTab(t.key)}
//               >
//                 {t.label}
//               </button>
//             ))}
//           </div>

//           {listError && <div className="ec-alert">{listError}</div>}

//           {loading ? (
//             <div className="ec-empty">Loading updates…</div>
//           ) : items.length === 0 ? (
//             <div className="ec-empty">
//               {status ? (
//                 <p>No {STATUS_LABEL[status].toLowerCase()} updates.</p>
//               ) : (
//                 <>
//                   <p>No updates yet.</p>
//                   <button className="ec-btn ec-btn-primary" onClick={openCreate}>
//                     <IoAdd size={18} /> Create your first update
//                   </button>
//                 </>
//               )}
//             </div>
//           ) : (
//             <div className="ec-grid-levels">
//               {items.map((u) => {
//                 const src = imageUrl(u.image);
//                 const busy = busyId === u._id;
//                 const expired = u.status === "expired";
//                 return (
//                   <article key={u._id} className="ec-card">
//                     <div className="hu-img-wrap">
//                       <img
//                         className="hu-img"
//                         src={src}
//                         alt={u.title}
//                         loading="lazy"
//                         onError={(e) => (e.currentTarget.style.visibility = "hidden")}
//                       />
//                       <span className={`hu-status hu-status-${u.status}`}>
//                         {STATUS_LABEL[u.status] || u.status}
//                       </span>
//                       <button
//                         type="button"
//                         className="hu-view-btn"
//                         onClick={() => setLightbox({ src, title: u.title })}
//                         aria-label={`View ${u.title} full size`}
//                       >
//                         <IoEyeOutline size={16} /> View
//                       </button>
//                     </div>

//                     <div className="ec-card-body">
//                       <h3 className="ec-card-title">{u.title}</h3>
//                       <dl className="hu-meta">
//                         <dt>Starts</dt>
//                         <dd>{formatDateTime(u.startAt)}</dd>
//                         <dt>Ends</dt>
//                         <dd>{formatDateTime(u.endAt)}</dd>
//                         <dt>Shows</dt>
//                         <dd>{FREQUENCY_LABEL[u.frequency] || u.frequency}</dd>
//                         <dt>Priority</dt>
//                         <dd>{u.priority}</dd>
//                         <dt>File</dt>
//                         <dd>{formatSize(u.imageSizeBytes)}</dd>
//                       </dl>
//                     </div>

//                     <div className="ec-card-actions">
//                       <button
//                         className="ec-btn ec-btn-ghost ec-btn-sm"
//                         onClick={() => toggleActive(u)}
//                         disabled={busy || expired}
//                         title={expired ? "Edit the end date to use this update again" : ""}
//                       >
//                         {u.isActive ? "Turn off" : "Turn on"}
//                       </button>
//                       <button
//                         className="ec-icon-btn"
//                         onClick={() => openEdit(u)}
//                         disabled={busy}
//                         title="Edit update"
//                         aria-label="Edit update"
//                       >
//                         <IoCreateOutline size={18} />
//                       </button>
//                       <button
//                         className="ec-icon-btn ec-icon-danger"
//                         onClick={() => deleteUpdate(u)}
//                         disabled={busy}
//                         title="Delete update"
//                         aria-label="Delete update"
//                       >
//                         <IoTrashOutline size={18} />
//                       </button>
//                     </div>
//                   </article>
//                 );
//               })}
//             </div>
//           )}

//           {pages > 1 && (
//             <div className="hu-pager">
//               <button
//                 className="ec-btn ec-btn-ghost ec-btn-sm"
//                 onClick={() => setPage((p) => Math.max(p - 1, 1))}
//                 disabled={page <= 1 || loading}
//               >
//                 Previous
//               </button>
//               <span className="ec-muted">
//                 Page {page} of {pages}
//               </span>
//               <button
//                 className="ec-btn ec-btn-ghost ec-btn-sm"
//                 onClick={() => setPage((p) => Math.min(p + 1, pages))}
//                 disabled={page >= pages || loading}
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </section>
//       </div>

//       {/* ================= FORM MODAL ================= */}
//       {modal && (
//         <div className="ec-overlay" onClick={closeModal}>
//           <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h3>{editingId ? "Edit update" : "New update"}</h3>
//               <button className="ec-icon-btn" onClick={closeModal} aria-label="Close">
//                 <IoClose size={20} />
//               </button>
//             </div>

//             <form className="ec-form" onSubmit={submit}>
//               {errors.submit && <div className="ec-alert">{errors.submit}</div>}

//               <div className="ec-fields">
//                 <div className="ec-field ec-full">
//                   <label>Name *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={form.title}
//                     onChange={handleChange}
//                     placeholder="e.g. Diwali 2026 offer"
//                     autoFocus
//                   />
//                   <span className="ec-hint">Only your team sees this. Users see just the image.</span>
//                   {errors.title && <span className="ec-error">{errors.title}</span>}
//                 </div>

//                 {/* image */}
//                 <div className="ec-field ec-full">
//                   <label>Image {!editingId && "*"}</label>
//                   <div className="ec-drop">
//                     {shownImage ? (
//                       <img className="hu-drop-img" src={shownImage} alt="Popup preview" />
//                     ) : (
//                       <div className="ec-drop-empty">
//                         <IoImageOutline size={22} />
//                         <span>JPG, PNG or WebP · up to 5 MB · 4:5 works best (1080 × 1350)</span>
//                       </div>
//                     )}
//                     <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
//                       {shownImage ? "Replace image" : "Choose image"}
//                       <input
//                         type="file"
//                         accept="image/jpeg,image/png,image/webp"
//                         onChange={pickImage}
//                         hidden
//                       />
//                     </label>
//                   </div>
//                   {imageFile && (
//                     <span className="ec-hint">
//                       {imageFile.name} · {formatSize(imageFile.size)}
//                     </span>
//                   )}
//                   {hint && (
//                     <span className={`ec-hint ${hint.ok ? "hu-hint-ok" : "hu-hint-warn"}`}>
//                       {hint.text}
//                     </span>
//                   )}
//                   {editingId && !imageFile && (
//                     <span className="ec-hint">
//                       Keep the current image, or replace it. Users who already closed the old image
//                       will see the new one.
//                     </span>
//                   )}
//                   {errors.image && <span className="ec-error">{errors.image}</span>}
//                 </div>

//                 <div className="ec-field">
//                   <label>Starts *</label>
//                   <input
//                     type="datetime-local"
//                     name="startAt"
//                     value={form.startAt}
//                     onChange={handleChange}
//                   />
//                   {errors.startAt && <span className="ec-error">{errors.startAt}</span>}
//                 </div>

//                 <div className="ec-field">
//                   <label>Ends *</label>
//                   <input
//                     type="datetime-local"
//                     name="endAt"
//                     value={form.endAt}
//                     onChange={handleChange}
//                   />
//                   {errors.endAt && <span className="ec-error">{errors.endAt}</span>}
//                 </div>

//                 <div className="ec-field">
//                   <label>How often to show</label>
//                   <select name="frequency" value={form.frequency} onChange={handleChange}>
//                     <option value="once">Once per device</option>
//                     <option value="daily">Once a day until it ends</option>
//                   </select>
//                 </div>

//                 <div className="ec-field">
//                   <label>Priority</label>
//                   <input
//                     type="number"
//                     name="priority"
//                     step="1"
//                     value={form.priority}
//                     onChange={handleChange}
//                   />
//                   <span className="ec-hint">If two updates are live, the higher number shows.</span>
//                   {errors.priority && <span className="ec-error">{errors.priority}</span>}
//                 </div>

//                 <div className="ec-field ec-full">
//                   <label className="ec-check">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={form.isActive}
//                       onChange={handleChange}
//                     />
//                     Turn on (shows to users between the start and end time)
//                   </label>
//                 </div>
//               </div>

//               {saving && (
//                 <div className="ec-progress" aria-label="Upload progress">
//                   <div className="ec-progress-bar" style={{ width: `${progress}%` }} />
//                   <span>{progress < 100 ? `Uploading… ${progress}%` : "Processing…"}</span>
//                 </div>
//               )}

//               <div className="ec-actions">
//                 <button
//                   type="button"
//                   className="ec-btn ec-btn-ghost"
//                   onClick={closeModal}
//                   disabled={saving}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="ec-btn ec-btn-primary" disabled={saving}>
//                   {saving ? "Saving…" : editingId ? "Save changes" : "Create update"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ================= FULL-SIZE PREVIEW ================= */}
//       {lightbox && (
//         <div className="ec-overlay" onClick={() => setLightbox(null)}>
//           <div className="ec-modal ec-modal-player" onClick={(e) => e.stopPropagation()}>
//             <div className="ec-modal-header">
//               <h3>{lightbox.title}</h3>
//               <button className="ec-icon-btn" onClick={() => setLightbox(null)} aria-label="Close">
//                 <IoClose size={20} />
//               </button>
//             </div>
//             <div className="ec-player">
//               <img className="hu-preview-img" src={lightbox.src} alt={lightbox.title} />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HomeUpdate;





import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  IoAdd,
  IoClose,
  IoCreateOutline,
  IoTrashOutline,
  IoImageOutline,
  IoEyeOutline,
} from "react-icons/io5";
// import "./EnglishCours.css"; // shared admin styles (ec-*). Adjust the path if needed.
import "./HomeUpdate.css"; // small extras for this page (hu-*)

// REACT_APP_API_BASEURL is expected to look like  http://localhost:5001/api
const API_BASE_URL = (process.env.REACT_APP_API_BASEURL || "").replace(/\/$/, "");
const BASE = `${API_BASE_URL}/admin/home-updates`;
// Images are saved in Uploads/ and served the same way as slides: <api>/uploads/<filename>
const UPLOADS_URL = `${API_BASE_URL}/uploads/`;

const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
const MAX_IMAGE = 5 * 1024 * 1024; // 5 MB (same limit the server enforces)
const PAGE_SIZE = 12;
const IDEAL_RATIO = 4 / 5; // recommended popup shape (e.g. 1080 x 1350)

const TABS = [
  { key: "", label: "All" },
  { key: "live", label: "Live" },
  { key: "scheduled", label: "Scheduled" },
  { key: "inactive", label: "Turned off" },
  { key: "expired", label: "Expired" },
];

const STATUS_LABEL = {
  live: "Live",
  scheduled: "Scheduled",
  inactive: "Turned off",
  expired: "Expired",
};

const FREQUENCY_LABEL = {
  once: "Once per device",
  daily: "Once a day",
  every_open: "Every app open",
};

const EMPTY_FORM = {
  title: "",
  startAt: "",
  endAt: "",
  priority: 0,
  frequency: "once",
  isActive: false,
};

// ---------- helpers ----------
const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const errMsg = (error, fallback = "Something went wrong. Please try again.") =>
  error?.response?.data?.message || fallback;

const imageUrl = (name) => (name ? `${UPLOADS_URL}${name}` : "");

const pad = (n) => String(n).padStart(2, "0");

// ISO / Date -> value for <input type="datetime-local"> in the admin's local time
const toLocalInput = (value) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

const formatDateTime = (value) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(d);
};

const formatSize = (bytes) => {
  const b = Number(bytes) || 0;
  if (!b) return "—";
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

// Read the picked image's pixel size in the browser (nothing is uploaded here).
const readImageSize = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });

const ratioHint = (size) => {
  if (!size?.width || !size?.height) return null;
  const ok = Math.abs(size.width / size.height - IDEAL_RATIO) <= 0.06;
  return {
    ok,
    text: ok
      ? `${size.width} × ${size.height}: good shape for phone screens.`
      : `${size.width} × ${size.height}: 4:5 (for example 1080 × 1350) fits phone screens best. Other shapes may look small or cropped.`,
  };
};

const HomeUpdate = () => {
  // ---------- shared ----------
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);

  const showToast = (type, text) => {
    setToast({ type, text });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  };

  useEffect(() => () => clearTimeout(toastTimer.current), []);

  // ---------- list ----------
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listError, setListError] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [busyId, setBusyId] = useState(null);

  // ---------- form modal ----------
  const [modal, setModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [progress, setProgress] = useState(0);

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [existingImage, setExistingImage] = useState("");
  const [imageSize, setImageSize] = useState(null);

  // ---------- full-size preview ----------
  const [lightbox, setLightbox] = useState(null); // { src, title }

  // ============================================================
  // object-URL housekeeping (avoid memory leaks)
  // ============================================================
  const previewRef = useRef("");
  useEffect(() => {
    previewRef.current = imagePreview;
  }, [imagePreview]);
  useEffect(
    () => () => {
      if (previewRef.current) URL.revokeObjectURL(previewRef.current);
    },
    []
  );

  const resetImage = () => {
    if (imagePreview) URL.revokeObjectURL(imagePreview);
    setImageFile(null);
    setImagePreview("");
    setExistingImage("");
    setImageSize(null);
  };

  // ============================================================
  // FETCH
  // ============================================================
  const fetchUpdates = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(BASE, {
        ...authHeaders(),
        params: { status: status || undefined, page, limit: PAGE_SIZE },
      });
      setItems(res.data?.data || []);
      setPages(res.data?.pages || 1);
      setTotal(res.data?.total || 0);
      setListError("");
    } catch (error) {
      console.log(error);
      setListError(errMsg(error, "Couldn't load updates. Please refresh."));
    } finally {
      setLoading(false);
    }
  }, [status, page]);

  useEffect(() => {
    fetchUpdates();
  }, [fetchUpdates]);

  const changeTab = (key) => {
    setStatus(key);
    setPage(1);
  };

  // ============================================================
  // FORM ACTIONS
  // ============================================================
  const openCreate = () => {
    resetImage();
    const now = new Date();
    const inAWeek = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
    setEditingId(null);
    setForm({
      ...EMPTY_FORM,
      startAt: toLocalInput(now),
      endAt: toLocalInput(inAWeek),
    });
    setErrors({});
    setProgress(0);
    setModal(true);
  };

  const openEdit = (u) => {
    resetImage();
    setEditingId(u._id);
    setForm({
      title: u.title || "",
      startAt: toLocalInput(u.startAt),
      endAt: toLocalInput(u.endAt),
      priority: u.priority ?? 0,
      frequency: u.frequency || "once",
      isActive: !!u.isActive,
    });
    setExistingImage(imageUrl(u.image));
    setImageSize(
      u.imageWidth && u.imageHeight ? { width: u.imageWidth, height: u.imageHeight } : null
    );
    setErrors({});
    setProgress(0);
    setModal(true);
  };

  const closeModal = () => {
    if (saving) return;
    resetImage();
    setModal(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const pickImage = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!IMAGE_TYPES.includes(file.type))
      return setErrors((p) => ({ ...p, image: "Use a JPG, PNG or WebP image." }));
    if (file.size > MAX_IMAGE)
      return setErrors((p) => ({ ...p, image: "Image must be 5 MB or smaller." }));

    setErrors((p) => ({ ...p, image: undefined }));
    if (imagePreview) URL.revokeObjectURL(imagePreview);
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
    setImageSize(await readImageSize(file));
  };

  const validate = () => {
    const e = {};
    if (!form.title.trim()) e.title = "Give this update a name.";
    else if (form.title.trim().length > 200) e.title = "Max 200 characters.";

    if (!editingId && !imageFile) e.image = "Choose the image to show.";

    const start = new Date(form.startAt);
    const end = new Date(form.endAt);
    if (!form.startAt || Number.isNaN(start.getTime())) e.startAt = "Pick a start date and time.";
    if (!form.endAt || Number.isNaN(end.getTime())) e.endAt = "Pick an end date and time.";
    if (!e.startAt && !e.endAt && end <= start) e.endAt = "End must be after the start.";

    if (form.priority === "" || !Number.isInteger(Number(form.priority)))
      e.priority = "Use a whole number.";

    setErrors((p) => ({ ...e, image: e.image || p.image }));
    return Object.keys(e).length === 0;
  };

  const submit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;

    const fd = new FormData();
    fd.append("title", form.title.trim());
    fd.append("startAt", new Date(form.startAt).toISOString());
    fd.append("endAt", new Date(form.endAt).toISOString());
    fd.append("priority", Number(form.priority));
    fd.append("frequency", form.frequency);
    fd.append("isActive", form.isActive);
    if (imageFile) fd.append("image", imageFile);

    try {
      setSaving(true);
      setProgress(0);
      const config = {
        ...authHeaders(),
        onUploadProgress: (p) => {
          if (p.total) setProgress(Math.round((p.loaded * 100) / p.total));
        },
      };
      if (editingId) {
        await axios.patch(`${BASE}/${editingId}`, fd, config);
        showToast("success", "Update saved.");
      } else {
        await axios.post(BASE, fd, config);
        showToast("success", "Update created.");
      }
      resetImage();
      setModal(false);
      fetchUpdates();
    } catch (error) {
      console.log(error);
      setErrors((p) => ({ ...p, submit: errMsg(error) }));
    } finally {
      setSaving(false);
    }
  };

  // ============================================================
  // LIST ACTIONS
  // ============================================================
  const toggleActive = async (u) => {
    try {
      setBusyId(u._id);
      await axios.patch(`${BASE}/${u._id}/toggle`, {}, authHeaders());
      showToast("success", u.isActive ? "Update turned off." : "Update turned on.");
      fetchUpdates();
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Couldn't change the update."));
    } finally {
      setBusyId(null);
    }
  };

  const deleteUpdate = async (u) => {
    if (!window.confirm(`Delete "${u.title}"? Its image will be removed from the server.`))
      return;
    try {
      setBusyId(u._id);
      await axios.delete(`${BASE}/${u._id}`, authHeaders());
      showToast("success", "Update deleted.");
      if (items.length === 1 && page > 1) setPage((p) => p - 1);
      else fetchUpdates();
    } catch (error) {
      console.log(error);
      showToast("error", errMsg(error, "Couldn't delete the update."));
    } finally {
      setBusyId(null);
    }
  };

  // ============================================================
  // RENDER
  // ============================================================
  const shownImage = imagePreview || existingImage;
  const hint = ratioHint(imageSize);

  return (
    <div id="add-subject-inner-wrapper">
      <div className="ec-page">
        {/* ---------- header ---------- */}
        <header className="ec-header">
          <div>
            <h1 className="ec-title">Home updates</h1>
            <p className="ec-subtitle">
              One image popup on the app’s home screen. Put any text, like “Diwali sale, 40% off”,
              inside the image itself.
            </p>
          </div>
          <button className="ec-btn ec-btn-primary" onClick={openCreate}>
            <IoAdd size={18} /> New update
          </button>
        </header>

        {toast && <div className={`ec-toast ec-toast-${toast.type}`}>{toast.text}</div>}

        {/* ---------- list ---------- */}
        <section>
          <div className="ec-section-head">
            <h2>Updates</h2>
            <span className="ec-count">{total}</span>
          </div>

          <div className="hu-tabs" role="tablist" aria-label="Filter updates">
            {TABS.map((t) => (
              <button
                key={t.key || "all"}
                type="button"
                role="tab"
                aria-selected={status === t.key}
                className={`hu-tab ${status === t.key ? "hu-tab-active" : ""}`}
                onClick={() => changeTab(t.key)}
              >
                {t.label}
              </button>
            ))}
          </div>

          {listError && <div className="ec-alert">{listError}</div>}

          {loading ? (
            <div className="ec-empty">Loading updates…</div>
          ) : items.length === 0 ? (
            <div className="ec-empty">
              {status ? (
                <p>No {STATUS_LABEL[status].toLowerCase()} updates.</p>
              ) : (
                <>
                  <p>No updates yet.</p>
                  <button className="ec-btn ec-btn-primary" onClick={openCreate}>
                    <IoAdd size={18} /> Create your first update
                  </button>
                </>
              )}
            </div>
          ) : (
            <div className="ec-grid-levels">
              {items.map((u) => {
                const src = imageUrl(u.image);
                const busy = busyId === u._id;
                const expired = u.status === "expired";
                return (
                  <article key={u._id} className="ec-card">
                    <div className="hu-img-wrap">
                      <img
                        className="hu-img"
                        src={src}
                        alt={u.title}
                        loading="lazy"
                        onError={(e) => (e.currentTarget.style.visibility = "hidden")}
                      />
                      <span className={`hu-status hu-status-${u.status}`}>
                        {STATUS_LABEL[u.status] || u.status}
                      </span>
                      <button
                        type="button"
                        className="hu-view-btn"
                        onClick={() => setLightbox({ src, title: u.title })}
                        aria-label={`View ${u.title} full size`}
                      >
                        <IoEyeOutline size={16} /> View
                      </button>
                    </div>

                    <div className="ec-card-body">
                      <h3 className="ec-card-title">{u.title}</h3>
                      <dl className="hu-meta">
                        <dt>Starts</dt>
                        <dd>{formatDateTime(u.startAt)}</dd>
                        <dt>Ends</dt>
                        <dd>{formatDateTime(u.endAt)}</dd>
                        <dt>Shows</dt>
                        <dd>{FREQUENCY_LABEL[u.frequency] || u.frequency}</dd>
                        <dt>Priority</dt>
                        <dd>{u.priority}</dd>
                        <dt>File</dt>
                        <dd>{formatSize(u.imageSizeBytes)}</dd>
                      </dl>
                    </div>

                    <div className="ec-card-actions">
                      <button
                        className="ec-btn ec-btn-ghost ec-btn-sm"
                        onClick={() => toggleActive(u)}
                        disabled={busy || expired}
                        title={expired ? "Edit the end date to use this update again" : ""}
                      >
                        {u.isActive ? "Turn off" : "Turn on"}
                      </button>
                      <button
                        className="ec-icon-btn"
                        onClick={() => openEdit(u)}
                        disabled={busy}
                        title="Edit update"
                        aria-label="Edit update"
                      >
                        <IoCreateOutline size={18} />
                      </button>
                      <button
                        className="ec-icon-btn ec-icon-danger"
                        onClick={() => deleteUpdate(u)}
                        disabled={busy}
                        title="Delete update"
                        aria-label="Delete update"
                      >
                        <IoTrashOutline size={18} />
                      </button>
                    </div>
                  </article>
                );
              })}
            </div>
          )}

          {pages > 1 && (
            <div className="hu-pager">
              <button
                className="ec-btn ec-btn-ghost ec-btn-sm"
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
                disabled={page <= 1 || loading}
              >
                Previous
              </button>
              <span className="ec-muted">
                Page {page} of {pages}
              </span>
              <button
                className="ec-btn ec-btn-ghost ec-btn-sm"
                onClick={() => setPage((p) => Math.min(p + 1, pages))}
                disabled={page >= pages || loading}
              >
                Next
              </button>
            </div>
          )}
        </section>
      </div>

      {/* ================= FORM MODAL ================= */}
      {modal && (
        <div className="ec-overlay" onClick={closeModal}>
          <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>{editingId ? "Edit update" : "New update"}</h3>
              <button className="ec-icon-btn" onClick={closeModal} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>

            <form className="ec-form" onSubmit={submit}>
              {errors.submit && <div className="ec-alert">{errors.submit}</div>}

              <div className="ec-fields">
                <div className="ec-field ec-full">
                  <label>Name *</label>
                  <input
                    type="text"
                    name="title"
                    value={form.title}
                    onChange={handleChange}
                    placeholder="e.g. Diwali 2026 offer"
                    autoFocus
                  />
                  <span className="ec-hint">Only your team sees this. Users see just the image.</span>
                  {errors.title && <span className="ec-error">{errors.title}</span>}
                </div>

                {/* image */}
                <div className="ec-field ec-full">
                  <label>Image {!editingId && "*"}</label>
                  <div className="ec-drop">
                    {shownImage ? (
                      <img className="hu-drop-img" src={shownImage} alt="Popup preview" />
                    ) : (
                      <div className="ec-drop-empty">
                        <IoImageOutline size={22} />
                        <span>JPG, PNG or WebP · up to 5 MB · 4:5 works best (1080 × 1350)</span>
                      </div>
                    )}
                    <label className="ec-btn ec-btn-ghost ec-btn-sm ec-file-btn">
                      {shownImage ? "Replace image" : "Choose image"}
                      <input
                        type="file"
                        accept="image/jpeg,image/png,image/webp"
                        onChange={pickImage}
                        hidden
                      />
                    </label>
                  </div>
                  {imageFile && (
                    <span className="ec-hint">
                      {imageFile.name} · {formatSize(imageFile.size)}
                    </span>
                  )}
                  {hint && (
                    <span className={`ec-hint ${hint.ok ? "hu-hint-ok" : "hu-hint-warn"}`}>
                      {hint.text}
                    </span>
                  )}
                  {editingId && !imageFile && (
                    <span className="ec-hint">
                      Keep the current image, or replace it. Users who already closed the old image
                      will see the new one.
                    </span>
                  )}
                  {errors.image && <span className="ec-error">{errors.image}</span>}
                </div>

                <div className="ec-field">
                  <label>Starts *</label>
                  <input
                    type="datetime-local"
                    name="startAt"
                    value={form.startAt}
                    onChange={handleChange}
                  />
                  {errors.startAt && <span className="ec-error">{errors.startAt}</span>}
                </div>

                <div className="ec-field">
                  <label>Ends *</label>
                  <input
                    type="datetime-local"
                    name="endAt"
                    value={form.endAt}
                    onChange={handleChange}
                  />
                  {errors.endAt && <span className="ec-error">{errors.endAt}</span>}
                </div>

                <div className="ec-field">
                  <label>How often to show</label>
                  <select name="frequency" value={form.frequency} onChange={handleChange}>
                    <option value="once">Once per device</option>
                    <option value="daily">Once a day until it ends</option>
                    <option value="every_open">Every time the app opens</option>
                  </select>
                </div>

                <div className="ec-field">
                  <label>Priority</label>
                  <input
                    type="number"
                    name="priority"
                    step="1"
                    value={form.priority}
                    onChange={handleChange}
                  />
                  <span className="ec-hint">If two updates are live, the higher number shows.</span>
                  {errors.priority && <span className="ec-error">{errors.priority}</span>}
                </div>

                <div className="ec-field ec-full">
                  <label className="ec-check">
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={form.isActive}
                      onChange={handleChange}
                    />
                    Turn on (shows to users between the start and end time)
                  </label>
                </div>
              </div>

              {saving && (
                <div className="ec-progress" aria-label="Upload progress">
                  <div className="ec-progress-bar" style={{ width: `${progress}%` }} />
                  <span>{progress < 100 ? `Uploading… ${progress}%` : "Processing…"}</span>
                </div>
              )}

              <div className="ec-actions">
                <button
                  type="button"
                  className="ec-btn ec-btn-ghost"
                  onClick={closeModal}
                  disabled={saving}
                >
                  Cancel
                </button>
                <button type="submit" className="ec-btn ec-btn-primary" disabled={saving}>
                  {saving ? "Saving…" : editingId ? "Save changes" : "Create update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= FULL-SIZE PREVIEW ================= */}
      {lightbox && (
        <div className="ec-overlay" onClick={() => setLightbox(null)}>
          <div className="ec-modal ec-modal-player" onClick={(e) => e.stopPropagation()}>
            <div className="ec-modal-header">
              <h3>{lightbox.title}</h3>
              <button className="ec-icon-btn" onClick={() => setLightbox(null)} aria-label="Close">
                <IoClose size={20} />
              </button>
            </div>
            <div className="ec-player">
              <img className="hu-preview-img" src={lightbox.src} alt={lightbox.title} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeUpdate;










